import React, { ReactNode, useCallback, useState } from 'react';
import { Button, Dialog, Grid, Typography } from '@mui/material';
import Delete from '@mui/icons-material/Delete';
import CustomIcon from 'components/Icon/CustomIcon';
import { useAuthContext } from 'context/auth.context';
import { hasPermissions } from 'config/ability';
import { ActivityAssignmentData } from 'hooks/activities/useQueryActivityAssignments';
import useMutationCancelActivityAssignment from 'hooks/activities/useMutationCancelActivityAssignment';
import { ActivityInterface } from 'pages/Activities/activities.context';

interface CancelActivityAssignmentProps {
  activity: Pick<ActivityInterface, 'subject'>;
  activityAssignment: ActivityAssignmentData;
  text?: ReactNode;
}

type Props = CancelActivityAssignmentProps;

const CancelActivityAssignment = ({ activity, activityAssignment, text }: Props) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const { ability } = useAuthContext();
  const [cancelActivityAssignment] = useMutationCancelActivityAssignment();

  const handleCancelClick = useCallback(async () => {
    await cancelActivityAssignment({
      variables: {
        input: {
          id: activityAssignment.id,
        },
      },
    });
    setShowCancelModal(false);
  }, [activityAssignment.id, cancelActivityAssignment]);

  // Return null if user does not have 'Delete' permissions
  if (!hasPermissions(ability, 'delete', 'Activity')) {
    return null;
  }

  return (
    <>
      <CustomIcon onClick={() => setShowCancelModal(true)} label={text} icon={<Delete />} />
      <Dialog open={showCancelModal} onClose={() => setShowCancelModal(false)}>
        <Grid container textAlign='center' p={2}>
          <Grid item xs={12}>
            <Typography variant='h5'>{activity.subject}</Typography>
            Are you sure you want to cancel this activity?
          </Grid>
          <Grid item xs={12}>
            <Button onClick={() => setShowCancelModal(false)}>No</Button>
            &nbsp;
            <Button onClick={handleCancelClick}>Yes</Button>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default CancelActivityAssignment;
